import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import {t} from "../common/i18n.js";
import InputSlider from "./input-slider.js";
import Stack from "./stack.js";
import {colors, fontFamily} from "./theme.js";
import {Text} from "./typo.js";
export default function ProductQuantitySlider(props) {
  const {value, min, max, step, onChange, ...rest} = props;
  const onInputChange = (e) => {
    const v = Number(e.target.value);
    onChange && onChange(v);
  };
  const announcementVisible = value >= max;
  return /* @__PURE__ */ React.createElement(Container, {
    ...rest
  }, /* @__PURE__ */ React.createElement(Inner, null, /* @__PURE__ */ React.createElement(Label, null, value, " ", t("Stk")), /* @__PURE__ */ React.createElement(InputContainer, null, /* @__PURE__ */ React.createElement(InputSlider, {
    value,
    step,
    min,
    max,
    onChange: onInputChange
  }))), announcementVisible && /* @__PURE__ */ React.createElement(Announcement, null, t("💡 Du möchtest mehr? Schreib uns gerne eine E-Mail an "), /* @__PURE__ */ React.createElement("a", {
    href: "mailto:service@printmate.de"
  }, "service@printmate.de")));
}
const Container = styled(Stack)``;
const Inner = styled.div`
  display: flex;
  align-items: center;
  height: 35px;
`;
const Label = styled.div`
  font-weight: 500;
  font-size: 14px;
  font-family: ${fontFamily.secondary};
  color: ${colors.b};
  margin-right: 16px;
  min-width: 60px;
`;
const InputContainer = styled.div`
  flex: 1;
`;
const Announcement = styled(Text)`
  font-size: 14px;
  padding: 5px;
`;
